import { formatNumber, formatPercent } from '/b2b/common/helpers/Number';
import { green, grey, orange, red } from '/b2b/common/colors';

import { LegendIcon } from '/b2b/common/components/Charts';
import camelCase from 'lodash/camelCase';
import { locale } from '/b2b/common/helpers/i18n';
import moment from 'moment';

export const ASSESSMENTS_BY_RISK_COLORS = [grey[400], green, orange, red];
export const ASSIGNMENTS_BY_STATUS_COLORS = ['#B66DFF', '#480091', green, red];
export const PRIVACY_SCORE_COLORS = [green, orange, red];

export const PIE_CHART_OPTIONS = {
    legend: {
        orient: 'horizontal',
        top: 'top',
        left: '3%',
        icon: 'circle',
        textStyle: {
            color: grey[800],
            fontSize: 13,
        },
    },
    series: [
        {
            type: 'pie',
            radius: '60%',
            data: [],
            label: {
                formatter(params) {
                    if (params.value === 0) {
                        return '';
                    } else {
                        return formatNumber(params.value, locale());
                    }
                },
            },
            labelLine: {
                show: false,
            },
        },
    ],
    label: {
        formatter(d) {
            return formatNumber(d.value, locale());
        },
        fontWeight: 'bold',
        position: 'outside',
        alignTo: 'edge',
        edgeDistance: 0,
    },
};

export const BAR_CHART_TOOLTIP = {
    confine: true,
    trigger: 'axis',
    axisPointer: {
        type: 'none',
    },
    formatter(params) {
        // For stacked bar charts, calculate the total and percentage for each series
        if (params.length > 1) {
            const values = {};
            let total = 0;
            let interval;

            params.forEach(param => {
                const valueKey = camelCase(param.seriesName);
                const value = param.data[valueKey];
                values[valueKey] = value;
                total += value;
                interval = param?.data?.interval || 'day';
            });

            // Format the date, check if dates are truncated by day, month, or year
            let dateFormat = 'MMM, YYYY';
            switch (interval) {
                case 'day':
                    dateFormat = 'MMM D, YYYY';
                    break;
                case 'month':
                    dateFormat = 'MMM, YYYY';
                    break;
                case 'year':
                    dateFormat = 'YYYY';
                    break;
            }

            let date;
            try {
                date = moment(params[0].axisValueLabel).format(dateFormat);
            } catch {
                date = params[0].axisValueLabel;
            }

            const loc = locale();
            let tooltipText = `<b>${date} (${formatNumber(total, loc)})</b><br/>`;

            params.forEach(param => {
                const valueKey = camelCase(param.seriesName);
                const value = values[valueKey];
                const percent = total > 0 ? (value / total) * 100 : 0;
                tooltipText += `${param.marker} ${param.seriesName}: <b>${formatPercent(percent, loc, 0)}</b> (${formatNumber(value, loc)})<br/>`;
            });

            return tooltipText;
        }

        // If there's only one item, use the default formatter
        const loc = locale();
        return `<b>${params[0].axisValueLabel}</b><br/>${params[0].marker} ${params[0].seriesName}: <b>${formatNumber(params[0].value, loc)}</b>`;
    },
};

export const COMMON_OPTIONS = {
    grid: {
        containLabel: true,
    },
    legend: {
        icon: LegendIcon,
        orient: 'horizontal',
        top: 'top',
    },
    xAxis: {
        axisLine: { show: true },
        axisTick: { show: false },
        splitLine: { show: false },
    },
    yAxis: {
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { show: true },
    },
    useUTC: true,
};

export { TIME_XAXIS_OPTIONS } from '/b2b/common/components/Charts';

export const VERTICAL_YAXIS_OPTIONS = {
    grid: {
        containLabel: true,
    },
    yAxis: {
        nameLocation: 'middle',
        nameTextStyle: {
            fontWeight: 'bold',
        },
    },
};
